<template>
  <div v-if="showDialog" class="login-modal" :style="{ top: '0px' }">
    <div class="modal-overlay"></div>
    <div class="modal-container" :style="modalStyle">
      <div
        style="font-size: 28px; color: #afa8a8; float: right; cursor: pointer"
        @click="closeLoginX"
      >
        x
      </div>
      <h2 style="text-align: center; margin-top: 10px; font-size: 18px">
        <img src="@/assets/images/login/logo.png" width="150" />
      </h2>
      <div style="text-align: center; font-size: 14px; color: #979899">
        {{ $t("login.slogan") }}
      </div>

      <!--            切换栏-->
      <el-tabs v-model="activeVal" style="text-align: center; margin-top: 10px">
        <el-tab-pane :label="$t('login.tabPersonal')" name="first">
          <!-- 表单-->
          <el-form ref="ruleForm" :model="form" class="demo-ruleForm">
            <div v-show="changeLoginFlag" class="company-login-class">
              <div id="phoneEmail" class="input-class">
                {{ $t("login.phoneOrEmail") }}
              </div>
              <el-input
                v-model="form.username"
                style="padding: 13px 0px"
                readonly
                onfocus="this.removeAttribute('readonly');"
                @focus="phoneEmailOnInputFocus"
                @blur="phoneEmailOnInputBlur"
                @input="personalPhoneEmailChange"
              ></el-input>
            </div>

            <div v-show="!changeLoginFlag" class="company-login-class">
              <div id="phone" class="input-class">
                {{ $t("login.phone") }}
              </div>
              <el-input
                v-model="form.phone"
                style="padding: 13px 0px"
                readonly
                onfocus="this.removeAttribute('readonly');"
                @focus="phoneOnInputFocus"
                @blur="phoneOnInputBlur"
                @input="personalPhoneChange"
              ></el-input>
              <div class="prompt">
                <span v-show="errorNamePhoneShow" class="prompt-span">{{ errorNamePhone }}</span>
              </div>
            </div>

            <div v-show="changeLoginFlag" class="company-login-class">
              <div id="password" class="input-class">
                {{ $t("login.password") }}
              </div>
              <el-input
                v-model="form.password"
                type="password"
                readonly
                onfocus="this.removeAttribute('readonly');"
                show-password
                style="padding: 13px 0px"
                @focus="passwordOnInputFocus"
                @blur="passwordOnInputBlur"
                @input="personalPasswordChange"
                @keyup.enter.native="usernamePersonalLoginEnter"
              ></el-input>
              <div class="prompt">
                <span v-show="errorPasswordPhonePersonalShow" class="prompt-span">{{
                  errorPasswordPhonePersonal
                }}</span>
              </div>
            </div>

            <div v-show="!changeLoginFlag && changeLoginCodeFlag" class="company-login-class">
              <div id="code" class="input-class">
                {{ $t("login.verifyCode") }}
              </div>
              <el-input
                v-model="form.code"
                readonly
                onfocus="this.removeAttribute('readonly');"
                style="padding: 13px 0px"
                @focus="codeOnInputFocus"
                @blur="codeOnInputBlur"
                @input="personalCodeChange"
                @keyup.enter.native="usernamePersonalLoginEnter"
              ></el-input>
              <el-button class="code-btn" :disabled="!show" @click.prevent="getCode()">
                <span v-show="show">{{ $t("login.getVerifyCode") }}</span>
                <span v-show="!show" class="count">{{ count }} s</span>
              </el-button>
              <div class="prompt">
                <span v-show="errorCodeShow" class="prompt-span">{{ errorCode }}</span>
              </div>
            </div>

            <div v-show="!changeLoginFlag && !changeLoginCodeFlag" class="company-login-class">
              <div id="imgCode" class="input-class">
                {{ $t("login.imageCode") }}
              </div>
              <el-input
                v-model="form.imgCode"
                readonly
                onfocus="this.removeAttribute('readonly');"
                style="padding: 13px 0px"
                @focus="imgCodeOnInputFocus"
                @blur="imgCodeOnInputBlur"
                @keyup.native="imgCodeKeyup()"
              ></el-input>
              <div class="img-code" @click="imgCodeClick">
                <img class="span_code2" :src="imgHtml" align="absmiddle" />
              </div>
              <div class="prompt">
                <span v-show="errorImgCodeShow" class="prompt-span">{{ errorImgCode }}</span>
              </div>
            </div>

            <div style="text-align: center; display: flex; margin-top: 30px">
              <el-button
                type="primary"
                class="login-button"
                style="cursor: pointer"
                :loading="usernamePersonalLoginLoading"
                @click="usernamePersonalLogin"
              >
                {{ $t("common.login") }}
              </el-button>
            </div>
            <div
              style="
                margin-top: 8px;
                display: flex;
                justify-content: space-around;
                margin-bottom: 10px;
              "
            >
              <div
                v-show="changeLoginFlag"
                style="font-size: 14px; color: #ff752d; cursor: pointer"
                @click="tabCode"
              >
                {{ $t("login.switchToPhoneLogin") }}
              </div>
              <div
                v-show="!changeLoginFlag"
                style="font-size: 14px; color: #ff752d; cursor: pointer"
                @click="tabCode"
              >
                {{ $t("login.switchToAccountLogin") }}
              </div>
            </div>
          </el-form>
        </el-tab-pane>

        <el-tab-pane :label="$t('login.tabEnterprise')" name="second">
          <!-- 表单-->
          <el-form ref="ruleForm" :model="formEnterprise" class="demo-ruleForm">
            <div class="company-login-class">
              <div id="phoneLogin" class="input-class">
                {{ $t("login.phoneShort") }}
              </div>
              <el-input
                v-model="formEnterprise.enterpriseUsername"
                style="padding: 13px 0px"
                readonly
                onfocus="this.removeAttribute('readonly');"
                @focus="phoneLoginOnInputFocus"
                @blur="phoneLoginOnInputBlur"
                @input="companyLoginChange"
              ></el-input>
            </div>

            <div class="company-login-class">
              <div id="companyLogin" class="input-class">
                {{ $t("login.enterpriseAccount") }}
              </div>
              <el-input
                v-model="formEnterprise.companyUsername"
                style="padding: 13px 0px"
                readonly
                onfocus="this.removeAttribute('readonly');"
                @focus="companyLoginOnInputFocus"
                @blur="companyLoginOnInputBlur"
                @input="companyLoginTwoChange"
              ></el-input>
            </div>

            <div class="company-login-class">
              <div id="companyPassword" class="input-class">
                {{ $t("login.password") }}
              </div>
              <el-input
                v-model="formEnterprise.companyPassword"
                type="password"
                readonly
                onfocus="this.removeAttribute('readonly');"
                show-password
                style="padding: 13px 0px"
                @focus="companyPasswordOnInputFocus"
                @blur="companyPasswordOnInputBlur"
                @input="companyPasswordChange"
                @keyup.enter.native="usernameCompanyLoginEnter"
              ></el-input>
              <div class="prompt">
                <span v-show="errorPasswordCompanyShow" class="prompt-span">{{
                  errorPasswordCompany
                }}</span>
              </div>
            </div>
            <div style="text-align: center; display: flex; margin-top: 30px">
              <el-button
                type="primary"
                class="login-button"
                style="cursor: pointer"
                :loading="usernameCompanyLoginLoading"
                @click="usernameCompanyLogin"
              >
                {{ $t("common.login") }}
              </el-button>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div class="login-agreement-class">
        {{ $t("login.agreement") }}
        <a href="https://www.dq123.com/wiki/detail/10" target="_blank">
          <span style="color: #c7c7c5">{{ $t("login.privacy") }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import UserLogin from "@/api/user-login";
export default {
  name: "Login",
  components: {},
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    activeName: {
      type: String,
      default: "first",
    },
  },
  data() {
    return {
      qqUrl: "",
      wxUrl: "",
      focusColor: "#FF6A00",
      blurColor: "#dedfe3",
      usernameCompanyLoginLoading: false,
      usernamePersonalLoginLoading: false,
      errorPasswordCompanyShow: false,
      errorPasswordCompany: "",
      errorPasswordPhonePersonalShow: false,
      errorPasswordPhonePersonal: "",
      show: "false",
      count: "",
      imgHtml: "",
      activeVal: "first",
      // 设置切换手机验证码登录或者个人账号登录的标识
      changeLoginFlag: true,
      // 设置切换微信或者账号登录
      changeLoginCodeFlag: false,

      isPhone: false,
      isEmail: false,
      // 个人表单
      form: {
        username: "",
        phone: "",
        password: "",
        code: "",
        imgCode: "",
        type: [],
      },
      // 企业表单
      formEnterprise: {
        enterpriseUsername: "",
        companyUsername: "",
        companyPassword: "",
        select: null,
      },
      errorCode: "",
      errorCodeShow: false,
      verificationCodePersonal: "",
      errorNamePhone: "",
      errorNamePhoneShow: false,
      errorImgCode: "",
      errorImgCodeShow: false,
      origin: "",
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.member.userId != null;
    },
    showDialog() {
      return this.$store.state.login.loginVisible;
    },
    modalStyle() {
      if (this.showDialog) {
        return {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
        };
      } else {
        return {
          display: "none",
        };
      }
    },
  },
  watch: {
    activeVal(oldVal, newVal) {
      this.form = {
        phoneNumber: "",
        password: "",
        phone: "",
        code: "",
        type: [],
      };
      this.formEnterprise = {
        enterpriseUsername: "",
        companyUsername: "",
        password: "",
        select: null,
      };
      newVal = this.activeName;
    },
  },
  mounted() {
    const url = new URL(window.location.href);
    this.origin = url.origin;
    this.imgHtml = this.origin + "/view/verifyCode/getVerifyCode";

    this.qqUrl =
      this.origin +
      "/view/member/oauth/qq/connect?redirect_uri=" +
      encodeURIComponent(window.location.href);

    this.wxUrl =
      this.origin +
      "/view/member/oauth/wx/connect?redirect_uri=" +
      encodeURIComponent(window.location.href);

    if (this.$route.query.op === "login" && !this.isLogin) {
      this.$store.commit("login/setLoginVisible", true);
    }
  },
  methods: {
    tabCode() {
      this.form = {
        username: "",
        phone: "",
        password: "",
        code: "",
        imgCode: "",
        type: [],
      };
      this.changeLoginFlag = !this.changeLoginFlag;
    },

    // 企业子账户回车登陆
    usernameCompanyLoginEnter() {
      if (!this.usernameCompanyLoginLoading) {
        this.usernameCompanyLogin();
      }
    },

    // 企业子账户登陆
    usernameCompanyLogin() {
      this.usernameCompanyLoginLoading = true;
      if (
        this.formEnterprise.enterpriseUsername === "" ||
        this.formEnterprise.companyUsername === "" ||
        this.formEnterprise.companyPassword === ""
      ) {
        this.$message({
          message: "请输入正确的账号名或密码",
          type: "warning",
        });
        this.usernameCompanyLoginLoading = false;
        return;
      }

      this.axios
        .post(UserLogin.loginMember, this.formEnterprise)
        .then((data) => {
          if (data === "成功") {
            this.$router.go(0);
          } else if (data === "请输入正确的账号名或密码") {
            this.$message.warning(data);
            this.usernameCompanyLoginLoading = false;
          } else {
            this.errorPasswordCompany = data;
            this.errorPasswordCompanyShow = true;
            this.usernameCompanyLoginLoading = false;
          }
        })
        .catch(() => {
          this.usernameCompanyLoginLoading = false;
        });
    },

    // 个人回车登录
    usernamePersonalLoginEnter() {
      if (!this.usernamePersonalLoginLoading) {
        this.usernamePersonalLogin();
      }
    },

    // 个人登陆
    usernamePersonalLogin() {
      this.usernamePersonalLoginLoading = true;
      if (this.changeLoginFlag) {
        if (this.form.username === "") {
          this.usernamePersonalLoginLoading = false;
          return false;
        }
        this.$store
          .dispatch("user/login", this.form)
          .then((res) => {
            if (res === "成功") {
              this.$router.go(0);
            } else {
              this.errorPasswordPhonePersonal = res;
              this.errorPasswordPhonePersonalShow = true;
              this.usernamePersonalLoginLoading = false;
            }
          })
          .catch(() => {
            this.usernamePersonalLoginLoading = false;
          });
      } else {
        if (this.form.phone === "") {
          this.usernamePersonalLoginLoading = false;
          return false;
        }
        if (this.form.code !== "" && this.verificationCodePersonal !== "") {
          if (this.form.code === this.verificationCodePersonal) {
            this.errorCodeShow = false;
            this.$store
              .dispatch("user/login", this.form)
              .then((res) => {
                if (res === "成功") {
                  this.$router.go(0);
                } else {
                  this.errorPasswordPhonePersonal = res;
                  this.errorPasswordPhonePersonalShow = true;
                  this.usernamePersonalLoginLoading = false;
                }
              })
              .catch(() => {
                this.usernamePersonalLoginLoading = false;
              });
          } else {
            this.errorCode = "请填写正确的验证码";
            this.errorCodeShow = true;
            this.usernamePersonalLoginLoading = false;
          }
        } else {
          this.usernamePersonalLoginLoading = false;
        }
      }
    },
    companyLoginChange() {
      this.errorPasswordCompanyShow = false;
    },
    companyLoginTwoChange() {
      this.errorPasswordCompanyShow = false;
    },
    companyPasswordChange() {
      this.errorPasswordCompanyShow = false;
    },
    // 监听input输入
    personalPhoneEmailChange() {
      this.errorPasswordPhonePersonalShow = false;
    },
    personalPasswordChange() {
      this.errorPasswordPhonePersonalShow = false;
    },
    personalPhoneChange() {
      //  this.errorPasswordPhonePersonalShow = false
    },

    personalCodeChange(e) {
      if (this.form.code === this.verificationCodePersonal) {
        this.errorCodeShow = false;
      } else {
        this.errorCode = "请填写正确的验证码";
        this.errorCodeShow = true;
      }
    },

    // 获取短信验证码
    getCode() {
      const that = this;
      // 个人
      if (!that.enterpriseFlag) {
        if (that.form.phone === "" || that.form.phone.length !== 11) {
          that.errorNamePhone = "请填写正确的手机号";
          that.errorNamePhoneShow = true;
          return false;
        } else {
          that.errorNamePhone = "";
          that.errorNamePhoneShow = false;
          that.axios
            .post(UserLogin.getUserMemberInfoCountByPhone, that.form)
            .then((data) => {
              if (data === "手机号已注册") {
                // 验证码倒计时
                if (!that.timer) {
                  that.count = 60;
                  that.show = false;
                  that.timer = setInterval(() => {
                    if (that.count > 0 && that.count <= 60) {
                      that.count--;
                    } else {
                      that.show = true;
                      clearInterval(that.timer);
                      that.timer = null;
                    }
                  }, 1000);

                  that.axios
                    .post(UserLogin.smsMsg, that.form)
                    .then((data) => {
                      if (data[0].code === "成功") {
                        that.verificationCodePersonal = data[0].smscode;
                      } else if (data[0].code === "失败") {
                        that.$message({
                          message: "短信验证码发送失败，请稍后重新发送",
                          type: "warning",
                        });
                      }
                    })
                    .finally(() => {
                      that.listLoading = false;
                    });
                }
              } else {
                that.errorNamePhone = "手机号码未注册";
                that.errorNamePhoneShow = true;
              }
            })
            .finally(() => {
              that.listLoading = false;
            });
        }
      }
    },

    // 监听input焦点，设置文字颜色
    phoneEmailOnInputFocus() {
      document.getElementById("phoneEmail").style.color = this.focusColor;
    },
    phoneEmailOnInputBlur() {
      document.getElementById("phoneEmail").style.color = this.blurColor;
    },
    phoneOnInputFocus() {
      document.getElementById("phone").style.color = this.focusColor;
    },
    phoneOnInputBlur() {
      document.getElementById("phone").style.color = this.blurColor;
    },
    passwordOnInputFocus() {
      document.getElementById("password").style.color = this.focusColor;
    },
    passwordOnInputBlur() {
      document.getElementById("password").style.color = this.blurColor;
    },
    codeOnInputFocus() {
      document.getElementById("code").style.color = this.focusColor;
    },
    codeOnInputBlur() {
      document.getElementById("code").style.color = this.blurColor;
    },
    imgCodeOnInputFocus() {
      document.getElementById("imgCode").style.color = this.focusColor;
    },
    imgCodeOnInputBlur() {
      document.getElementById("imgCode").style.color = this.blurColor;
    },
    phoneLoginOnInputFocus() {
      document.getElementById("phoneLogin").style.color = this.focusColor;
    },
    phoneLoginOnInputBlur() {
      document.getElementById("phoneLogin").style.color = this.blurColor;
    },
    companyLoginOnInputFocus() {
      document.getElementById("companyLogin").style.color = this.focusColor;
    },
    companyLoginOnInputBlur() {
      document.getElementById("companyLogin").style.color = this.blurColor;
    },
    companyPasswordOnInputFocus() {
      document.getElementById("companyPassword").style.color = this.focusColor;
    },
    companyPasswordOnInputBlur() {
      document.getElementById("companyPassword").style.color = this.blurColor;
    },

    // 点击刷新图形验证码
    imgCodeClick() {
      this.form.imgCode = "";
      this.imgHtml = this.origin + "/view/verifyCode/getVerifyCode?a=" + new Date().getTime();
    },

    imgCodeKeyup() {
      if (this.form.imgCode.toUpperCase() === Cookies.get("verifyCode")) {
        this.changeLoginFlag = false;
        this.changeLoginCodeFlag = true;
      } else {
        this.errorImgCode = "请填写正确的图形验证码";
        this.errorImgCodeShow = true;
      }
    },
    // 个人登录跳转到个人注册
    registerPerson() {
      this.form = {
        phoneNumber: "",
        password: "",
        phone: "",
        code: "",
        type: [],
      };
      this.$emit("registerPersonal");
    },

    // 个人登录跳转到个人忘记密码
    forgotPerson() {
      this.form = {
        phoneNumber: "",
        password: "",
        code: "",
        type: [],
      };
      this.$emit("forgotPersonal");
    },

    // 企业登录跳转到企业忘记密码
    companyForgot() {
      this.formEnterprise = {
        enterpriseUsername: "",
        companyUsername: "",
        password: "",
        select: null,
      };
      this.$emit("forgotCompany");
    },

    // 企业登录跳转到企业注册
    goRegister() {
      this.formEnterprise = {
        enterpriseUsername: "",
        companyUsername: "",
        password: "",
        select: null,
      };
      this.$emit("close");
    },
    // x关闭符号
    closeLoginX() {
      this.errorNamePhoneShow = false;
      this.errorImgCodeShow = false;
      this.changeLoginCodeFlag = false;
      this.changeLoginFlag = true;
      this.formEnterprise = {
        enterpriseUsername: "",
        companyUsername: "",
        password: "",
        select: null,
      };
      this.form = {
        phoneNumber: "",
        password: "",
        code: "",
        type: [],
      };
      this.$emit("closeLogin");
    },
  },
};
</script>

<style scoped>
.login-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.login-modal ::v-deep .el-tabs__nav-wrap.is-scrollable {
  padding: 0 !important;
}

.login-modal ::v-deep .el-tabs__nav-prev {
  display: none !important;
}
.login-modal ::v-deep .el-tabs__nav-next {
  display: none !important;
}

/* 默认情况下隐藏横向滚动条 */
.login-modal ::v-deep .el-tabs__nav-scroll {
  width: 100% !important;
  overflow-x: auto !important;
}

/* 隐藏滚动条 */
.login-modal ::v-deep .el-tabs__nav-scroll::-webkit-scrollbar {
  display: none;
}

.login-modal .prompt {
  position: absolute;
  left: 0%;
  top: 55px;
  z-index: 9999;
  background-color: #ffffff;
  color: #dedfe3;
  font-size: 15px;
}

.login-modal .prompt-span {
  float: left;
  color: red;
  font-size: 12px;
}

.login-modal .span_code2 {
  width: 80px;
  float: left;
  height: 30px;
  line-height: 30px;
  background-color: #047ceb;
  color: #fff;
  border-top: 1px solid #c8c8c8;
  border-bottom: 1px solid #c8c8c8;
  border-right: 1px solid #c8c8c8;
  cursor: pointer;
  text-align: center;
}
.login-modal .company-login-class {
  position: relative;
  height: 70px;
}
.login-modal .login-button {
  width: 200px;
  height: 50px;
  border-radius: 30px;
  color: white;
  background-color: #ff752d;
  margin: 20px auto;
}

.login-modal .login-agreement-class {
  position: absolute;
  text-align: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  right: 0px;
  width: 100%;
  height: 30px;
  background-color: #fafafa;
  line-height: 30px;
  color: #c7c7c5;
  font-size: 12px;
}

.login-modal .img-code {
  position: absolute;
  right: 3%;
  top: 18px;
  z-index: 9999;
  background-color: #ffffff;
  color: #dedfe3;
}

.login-modal .input-class {
  position: absolute;
  left: 5%;
  top: 0;
  z-index: 9999;
  background-color: #ffffff;
  color: #dedfe3;
  font-size: 15px;
}

.login-modal .modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.login-modal .modal-container {
  position: relative;
  width: 19rem;
  margin: auto;
  border-radius: 10px;
  padding: 10px 20px 10px 20px;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.login-modal .code-btn {
  width: 86px;
  height: 20px;
  position: absolute;
  top: 14px;
  right: 2px;
  z-index: 222;
  color: #ff6a00;
  font-size: 14px;
  border: none;
  /* border-left: 1px solid #bababa; */
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
}

.login-modal .modal-container h2 {
  margin-top: 0;
}

.login-modal ::v-deep .el-tabs__nav-wrap {
  margin-left: 2.5rem;
}

.login-modal ::v-deep .el-tabs__nav-wrap::after {
  width: 0;
}

.login-modal ::v-deep .el-tabs__nav {
  width: 210px;
}

.login-modal ::v-deep .el-tabs__item.is-active {
  color: #ff752d;
}

.login-modal ::v-deep .el-tabs__item {
  color: #ccd2da;
}

.login-modal ::v-deep .el-tabs__item:hover {
  color: #ff752d;
}

.login-modal ::v-deep .el-tabs__active-bar {
  background-color: #ff752d;
  width: 100px !important;
}

.login-modal ::v-deep .el-input__inner:focus {
  border-color: #ff752d;
  z-index: 9999;
}

.login-modal ::v-deep .el-select .el-input__inner:focus {
  border-color: #ff752d;
}

.login-modal ::v-deep .el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: #ff752d;
}

.login-modal ::v-deep .el-checkbox__inner {
  border-color: #ff752d;
}

.login-modal ::v-deep .el-checkbox__inner:focus {
  border-color: #ff752d;
}

.login-modal .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ffffff;
  border-color: #ff752d;
}

.login-modal[data-v-c27482c4] ::v-deep .el-tabs__item.is-active {
  font-size: 16px;
}
.login-modal[data-v-c27482c4] ::v-deep .el-tabs__item {
  font-size: 16px;
}
.login-modal[data-v-65293c90] ::v-deep .el-checkbox__inner {
  border-color: #d5d1d1;
}
</style>
